<template>
	<div class="stars">
		<div v-for="index in flatNumber" :key="index" class="sstar">
			<img :src="normalIcon" />
		</div>
		<div v-if="hasPlus" class="sstarplus">
			<img :src="plusIcon" />
		</div>
	</div>
</template>

<script>
	import {mapState} from 'vuex';
	export default {
		props: {
			stars: String
		},
		computed: {
			...mapState({
				svgIconUrl: 'svgIconUrl'
			}),
			hasPlus(){
				return this.stars.indexOf('.') !== -1 || this.stars.indexOf(' plus') !== -1  || this.stars.indexOf(',') !== -1;
			},
			flatNumber(){
				return (this.hasPlus) ? Number(this.stars.replace(' plus','').split('.')[0].split(',')[0]) : Number(this.stars) ;
			},
			plusIcon(){
				return this.svgIconUrl+'s-star-plus.svg';
			},
			normalIcon(){
				return this.svgIconUrl+'s-star.svg';
			}
		}
	}
</script>

<style scoped>

</style>
